import { render, staticRenderFns } from "./headcount.vue?vue&type=template&id=572cc748&scoped=true"
import script from "./headcount.vue?vue&type=script&lang=js"
export * from "./headcount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572cc748",
  null
  
)

export default component.exports